"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[595],{

/***/ 354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MM": function() { return /* binding */ listingRearranger; },
/* harmony export */   "eS": function() { return /* binding */ contentRearranger; }
/* harmony export */ });
function contentRearranger(param) {
    var content = param.content, _useVideoAd = param.useVideoAd, useVideoAd = _useVideoAd === void 0 ? true : _useVideoAd, _adsOptions = param.adsOptions, adsOptions = _adsOptions === void 0 ? {
        enableMobile: true,
        enableDesktop: true,
        positionMobile: 4,
        positionDesktop: 4
    } : _adsOptions, _videoAdOptions = param.videoAdOptions, videoAdOptions = _videoAdOptions === void 0 ? {
        enableMobile: true,
        enableDesktop: true,
        positionMobile: 1,
        positionDesktop: 2
    } : _videoAdOptions, _shouldUseIdCountPosition = param.shouldUseIdCountPosition, shouldUseIdCountPosition = _shouldUseIdCountPosition === void 0 ? true : _shouldUseIdCountPosition;
    var length = content === null || content === void 0 ? void 0 : content.length;
    var maxIdCountPosition = 10;
    if (length < adsOptions.positionMobile && length < adsOptions.positionDesktop) return content;
    var isValidDesktop = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return i % adsOptions.positionDesktop === 0 && i >= adsOptions.positionDesktop && i < length && adsOptions.enableDesktop;
    };
    var isValidMobile = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return i % adsOptions.positionMobile === 0 && i >= adsOptions.positionMobile && i < length && adsOptions.enableMobile;
    };
    var shouldRenderVideoAdMobile = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return useVideoAd && videoAdOptions.enableMobile && i === adsOptions.positionMobile * videoAdOptions.positionMobile;
    };
    var shouldRenderVideoAdDesktop = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return useVideoAd && videoAdOptions.enableDesktop && i === adsOptions.positionDesktop * videoAdOptions.positionDesktop;
    };
    var contentRearranged = [];
    var adMobileCount = 1;
    var adDesktopCount = 1;
    var adVideoM = {
        tipo: "adVideoGtmMobile"
    };
    var adVideoD = {
        tipo: "adVideoGtmDesktop"
    };
    content.forEach(function(block, i) {
        var adMobile = {
            tipo: "adMobile",
            idCountPosition: shouldUseIdCountPosition && adMobileCount <= maxIdCountPosition ? adMobileCount.toString() : ""
        };
        var adDesktop = {
            tipo: "adDesktop",
            idCountPosition: shouldUseIdCountPosition && adDesktopCount <= maxIdCountPosition ? adDesktopCount.toString() : ""
        };
        if (content.length >= 4 && i === 4) {
            contentRearranged.push({
                tipo: "cardCTA"
            });
        }
        if (i === 1) {
            contentRearranged.push(adMobile);
            adMobileCount += 1;
            contentRearranged.push(adDesktop);
            adDesktopCount += 1;
        }
        if (isValidMobile(i) && shouldRenderVideoAdMobile(i)) contentRearranged.push(adVideoM);
        if (isValidMobile(i) && !shouldRenderVideoAdMobile(i)) {
            if (adMobileCount <= maxIdCountPosition) contentRearranged.push(adMobile);
            if (adMobileCount <= maxIdCountPosition) adMobileCount += 1;
        }
        if (isValidDesktop(i) && shouldRenderVideoAdDesktop(i)) contentRearranged.push(adVideoD);
        if (isValidDesktop(i) && !shouldRenderVideoAdDesktop(i)) {
            if (adDesktopCount <= maxIdCountPosition) contentRearranged.push(adDesktop);
            if (adDesktopCount <= maxIdCountPosition) adDesktopCount += 1;
        }
        contentRearranged.push(block);
        if (content.length > 9 && i === 8) {
            contentRearranged.push({
                tipo: "readMore"
            });
        }
    });
    return contentRearranged;
}
var adsContainsMobile = {
    ads: true,
    mobile: true
};
var adsContainsDesktop = {
    ads: true,
    mobile: false
};
function listingRearranger(param) {
    var content = param.content, primary = param.primary, _hasNoAds = param.hasNoAds, hasNoAds = _hasNoAds === void 0 ? false : _hasNoAds, _sizeMobile = param.sizeMobile, sizeMobile = _sizeMobile === void 0 ? 3 : _sizeMobile, _sizeDesktop = param.sizeDesktop, sizeDesktop = _sizeDesktop === void 0 ? 6 : _sizeDesktop;
    var length = content === null || content === void 0 ? void 0 : content.length;
    var result = [];
    if (!primary) {
        result.push(adsContainsDesktop);
    }
    var chunkified = [];
    content.forEach(function(element, index) {
        chunkified.push(element);
        if ((index + 1) % sizeMobile === 0 && index + 1 >= sizeMobile && !hasNoAds) chunkified.push(adsContainsMobile);
        if ((index + 1) % sizeDesktop === 0 && index + 1 >= sizeDesktop) {
            result.push({
                chunck: chunkified
            });
            if (index + 1 < length && !hasNoAds) result.push(adsContainsDesktop);
            chunkified = [];
        }
        if (chunkified.length > 0 && length === index + 1) {
            result.push({
                chunck: chunkified
            });
        }
    });
    return result;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    contentRearranger: contentRearranger,
    listingRearranger: listingRearranger
});


/***/ }),

/***/ 595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NewsItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Layout/Breadcrumb/index.tsx + 1 modules
var Breadcrumb = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
;// CONCATENATED MODULE: ./src/components/Layout/InternalCredits/index.tsx




function InternalCredits(param) {
    var autoria = param.autoria, urlAutoria = param.urlAutoria, editoria = param.editoria, urlEditoria = param.urlEditoria, datas = param.datas, _type = param.type, type = _type === void 0 ? "" : _type;
    var rel = {};
    if (type === "artigo" || type === "analise") Object.assign(rel, {
        rel: "author"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "mt-2 text-base font-light text-mglGray700 [&>a]:cursor-pointer [&>a]:text-mglGray700 [&>a]:no-underline",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Por\xa0",
                    urlAutoria ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: "text-mglBlue600 text-opacity-100 shadow-[inset_0_-8px_0_0_rgb(39_169_225_/_10%)] transition-all duration-500 hover:shadow-[inset_0_-1.15em_0_rgb(39_169_225_/_10%)]",
                        style: {
                            color: designSystemColors/* mglBlue.mglBlue600 */.Db.mglBlue600
                        },
                        href: urlAutoria
                    }, rel), {
                        children: autoria
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            " ",
                            autoria,
                            " "
                        ]
                    }),
                    typeof editoria !== "undefined" && editoria !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "\xa0• Editado por\xa0",
                            urlEditoria ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-mglBlue600 text-opacity-100 shadow-[inset_0_-8px_0_0_rgb(39_169_225_/_10%)] transition-all duration-500 hover:shadow-[inset_0_-1.15em_0_rgb(39_169_225_/_10%)]",
                                style: {
                                    color: designSystemColors/* mglBlue.mglBlue600 */.Db.mglBlue600
                                },
                                href: urlEditoria,
                                children: editoria
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    " ",
                                    editoria,
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }),
            datas.PublicacaoFormatada && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "\xa0|\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                        dateTime: datas.Publicacao,
                        children: datas.PublicacaoFormatada
                    })
                ]
            }),
            datas.AtualizacaoFormatada && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "\xa0•\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("time", {
                        dateTime: datas.Atualizacao,
                        children: [
                            "Atualizado ",
                            datas.AtualizacaoFormatada
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/InternalTitle/index.tsx
var InternalTitle = __webpack_require__(2434);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
;// CONCATENATED MODULE: ./src/components/Internals/Header/index.tsx





function Header(param) {
    var breadcrumb = param.breadcrumb, titulo = param.titulo, publicacao = param.publicacao, _isAdvertorial = param.isAdvertorial, isAdvertorial = _isAdvertorial === void 0 ? false : _isAdvertorial, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _type = param.type, type = _type === void 0 ? "" : _type;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var headerSpan = currentSpan && currentSpan.startChild({
        op: "header"
    });
    var datas = {
        Publicacao: publicacao.dataPublicacao,
        PublicacaoFormatada: publicacao.dataPublicacaoFormatada,
        Atualizacao: publicacao.dataAtualizacao,
        AtualizacaoFormatada: publicacao.dataAtualizacaoFormatada
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                breadcrumbList: breadcrumb,
                isSubDomain: isSubDomain
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalTitle/* default */.Z, {
                title: titulo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalCredits, {
                autoria: publicacao.autor.nome,
                urlAutoria: publicacao.autor.link,
                editoria: publicacao.editor && !isAdvertorial ? publicacao.editor.nome : null,
                urlEditoria: publicacao.editor && !isAdvertorial ? publicacao.editor.link : null,
                datas: datas,
                type: type
            }),
            headerSpan && headerSpan.finish()
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./src/components/Layout/ItemListLastNews/styles.tsx
var styles = __webpack_require__(2747);
// EXTERNAL MODULE: ./src/components/Ads/Google/AdsTypeGeneratorsMemo/index.tsx
var AdsTypeGeneratorsMemo = __webpack_require__(9831);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(264);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./src/components/Internals/NewsItem/styles.tsx
var NewsItem_styles = __webpack_require__(6561);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./src/components/Layout/IFrameYoutube/index.tsx
var IFrameYoutube = __webpack_require__(3251);
// EXTERNAL MODULE: ./src/components/Internals/HeaderImage/index.tsx
var HeaderImage = __webpack_require__(8964);
// EXTERNAL MODULE: ./src/components/Ads/Rearrangers/index.ts
var Rearrangers = __webpack_require__(354);
;// CONCATENATED MODULE: ./src/components/Ads/AdVideoGtm/index.tsx


/**
 * Container vazio para o anúncio de vídeo in-content servido pelo GTM.
 *
 * Substitui os antigos componentes Truvid/Membrana, que carregavam o script de
 * terceiros diretamente no React. Agora o React apenas renderiza o contêiner
 * posicionado (`data-ad`) e sinaliza `ad_container_ready` no dataLayer; o GTM
 * decide (por categoria, via dataLayer) qual player de vídeo injetar aqui.
 */ function AdVideoGtm(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "desktop" : _variant;
    (0,react.useEffect)(function() {
        var ref = window || {}, adContainerReadyFired = ref.adContainerReadyFired, dataLayer = ref.dataLayer;
        if (!adContainerReadyFired && dataLayer) {
            dataLayer.push({
                event: "ad_container_ready"
            });
            window.adContainerReadyFired = true;
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "div-video-ad-".concat(variant),
        className: "videoAdPos",
        "data-ad": "true"
    });
}

// EXTERNAL MODULE: ./src/components/Internals/NewsContent/styles.tsx
var NewsContent_styles = __webpack_require__(2657);
// EXTERNAL MODULE: ./src/components/Internals/CustomComponentComposer/index.tsx + 5 modules
var CustomComponentComposer = __webpack_require__(5001);
// EXTERNAL MODULE: ./src/components/Internals/ContentComposer/index.tsx + 1 modules
var ContentComposer = __webpack_require__(944);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Layout/ChannelsCard/index.tsx


function ChannelsCard() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-[24px] flex flex-col items-center justify-between gap-4 rounded-md bg-white p-4 text-center shadow-mdc-elevation-z9-3 outline outline-2 outline-[#25D366] phone:flex-row phone:text-left",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center gap-x-4 text-ellipsis ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "Canaltech",
                        width: 57,
                        height: 57,
                        src: "https://img.canaltech.com.br/canaltech-icon.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm font-semibold",
                                children: "O Canaltech est\xe1 no WhatsApp!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs font-light",
                                children: "Entre no canal e acompanhe not\xedcias e dicas de tecnologia"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col items-center justify-center tablet:flex-row tablet:justify-between desktop:flex-col largeDesktop:flex-row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "canal-ct-wpp",
                    href: "https://canalte.ch/canaltech-no-whatsapp-site",
                    target: "_blank",
                    title: "WhatsApp Canaltech",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-[136px] items-center justify-center rounded-[80px] bg-[#25D366] p-2 text-center text-xs text-white transition transition-all ease-in hover:bg-black",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "mdi:whatsapp",
                                fontSize: "0.50rem"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-2",
                                children: "WhatsApp"
                            })
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/ArticleSource/index.tsx


function injectLinkSafety(html) {
    return html.replace(/<a\b([^>]*)>/gi, function(_match, attrs) {
        var updated = attrs;
        if (!/\btarget\s*=/.test(updated)) {
            updated += ' target="_blank"';
        }
        if (!/\brel\s*=/.test(updated)) {
            updated += ' rel="noopener noreferrer"';
        }
        return "<a".concat(updated, ">");
    });
}
function ArticleSource(param) {
    var fonte = param.fonte;
    var html = (0,react.useMemo)(function() {
        return injectLinkSafety(fonte);
    }, [
        fonte
    ]);
    if (!(fonte === null || fonte === void 0 ? void 0 : fonte.trim())) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-label": "Fontes",
        className: "mt-8 border-t border-mglGray200 pt-4 text-sm text-mglGray500 [&_a]:text-mglBlue400 [&_a]:underline [&_a]:hover:text-mglBlue500",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "mb-2 font-lexend text-base font-semibold text-mglGray700",
                children: "Fonte"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: html
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Internals/NewsContent/index.tsx
/* eslint-disable no-shadow */ /* eslint-disable react/no-array-index-key */ 














var MoreAbout = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6790).then(__webpack_require__.bind(__webpack_require__, 6790));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6790)
            ];
        }
    }
});
function NewsContent(param) {
    var dataContent = param.dataContent, _widget = param.widget, widget = _widget === void 0 ? null : _widget, _placeholderAds = param.placeholderAds, placeholderAds = _placeholderAds === void 0 ? false : _placeholderAds, _shouldRenderAdsGoogle = param.shouldRenderAdsGoogle, shouldRenderAdsGoogle = _shouldRenderAdsGoogle === void 0 ? true : _shouldRenderAdsGoogle, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _product = param.product, product = _product === void 0 ? null : _product, _titulo = param.titulo, titulo = _titulo === void 0 ? "" : _titulo, _hasPartnerLinks = param.hasPartnerLinks, hasPartnerLinks = _hasPartnerLinks === void 0 ? false : _hasPartnerLinks, _isNewsOpen = param.isNewsOpen, isNewsOpen = _isNewsOpen === void 0 ? false : _isNewsOpen, _mainCategory = param.mainCategory, mainCategory = _mainCategory === void 0 ? "" : _mainCategory, _fonte = param.fonte, fonte = _fonte === void 0 ? "" : _fonte;
    var ref;
    var transaction = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getTransaction();
    var newsContentSpan = transaction && transaction.startChild({
        op: "newsContent"
    });
    var chunckContent = (0,Rearrangers/* contentRearranger */.eS)({
        content: dataContent.conteudo,
        useVideoAd: !hasPartnerLinks
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("phone"), 1), isMobile = ref1[0];
    var ref2 = (0,react.useState)(isNewsOpen), isOpen = ref2[0], setOpened = ref2[1];
    var handleClickOpened = function() {
        setOpened(!isOpen);
    };
    var whenMobileAndShortContent = isMobile && dataContent.conteudo.length < 9;
    var shouldRenderFullWhenMainCategoryIsMatch = [
        "Ci\xeancia",
        "Entretenimento"
    ].includes(mainCategory);
    var shouldShowFonte = shouldRenderFullWhenMainCategoryIsMatch || isOpen || !isMobile || whenMobileAndShortContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!widget && /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreAbout, {
                type: widget.tipo,
                dados: widget.dados,
                isSubDomain: isSubDomain,
                product: product && {
                    preco: product.preco,
                    encurtador: product.encurtador || product.url
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsContent_styles/* DivContentNews */._7, {
                children: [
                    chunckContent === null || chunckContent === void 0 ? void 0 : chunckContent.map(function(partHtml, index) {
                        var idCountPosition = partHtml.idCountPosition ? partHtml.idCountPosition : "";
                        var whenMobileAndLongContentAndReadMore = isMobile && dataContent.conteudo.length >= 8 && chunckContent.indexOf(partHtml) <= 14 && !isOpen;
                        var shouldShow = shouldRenderFullWhenMainCategoryIsMatch || isOpen || !isMobile || whenMobileAndShortContent || whenMobileAndLongContentAndReadMore;
                        if (partHtml.tipo === "cardCTA") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelsCard, {})
                            }, index);
                        }
                        if (partHtml.tipo === "adMobile") {
                            var adMobileSpan = newsContentSpan && newsContentSpan.startChild({
                                op: "adRectangleMainInternalM"
                            });
                            return isMobile && shouldRenderAdsGoogle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,className/* default */.Z)(shouldShow ? "flex" : "hidden", " min-h-[340px] flex-col"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mb-1 h-3 text-center text-[10px] uppercase tracking-[0.05em] text-mglGray500",
                                        children: "Continua ap\xf3s a publicidade"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                                        isPlaceholder: placeholderAds,
                                        type: "rectangle/main/internal",
                                        marginBottomP: "24px",
                                        idCountPosition: idCountPosition
                                    }, index),
                                    adMobileSpan && adMobileSpan.finish()
                                ]
                            }, "".concat(index));
                        }
                        if (partHtml.tipo === "adDesktop") {
                            var adDesktopSpan = newsContentSpan && newsContentSpan.startChild({
                                op: "adRectangleMainInternalD"
                            });
                            return !isMobile && shouldRenderAdsGoogle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,className/* default */.Z)(shouldShow ? "flex" : "hidden", " min-h-[340px] flex-col"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mb-1 h-3 text-center text-[10px] uppercase tracking-[0.05rem] text-mglGray500",
                                        children: "Continua ap\xf3s a publicidade"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                                        isPlaceholder: placeholderAds,
                                        type: "rectangle/main/internal",
                                        marginBottomP: "24px",
                                        idCountPosition: idCountPosition
                                    }, index),
                                    adDesktopSpan && adDesktopSpan.finish()
                                ]
                            }, "".concat(index));
                        }
                        if (partHtml.tipo === "adVideoGtmDesktop" && !isMobile) {
                            var adVideoSpan = newsContentSpan && newsContentSpan.startChild({
                                op: "adVideoGtm"
                            });
                            return !isMobile && !hasPartnerLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,className/* default */.Z)(shouldShow ? "block" : "hidden", "z-[2] mx-auto mb-4 aspect-video h-full w-full items-center justify-center bg-black/5 [&>.videoAdPos]:grid [&>.videoAdPos]:aspect-video [&>.videoAdPos]:items-center", placeholderAds && "bg-mglGray200 text-mglGray300 before:flex before:h-full before:items-center before:justify-center before:content-['PUBLICIDADE']"),
                                children: [
                                    !placeholderAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdVideoGtm, {
                                        variant: "desktop"
                                    }),
                                    adVideoSpan && adVideoSpan.finish()
                                ]
                            }, "".concat(index));
                        }
                        if (partHtml.tipo === "adVideoGtmMobile" && isMobile) {
                            var adVideoSpan1 = newsContentSpan && newsContentSpan.startChild({
                                op: "adVideoGtm"
                            });
                            return isMobile && !hasPartnerLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,className/* default */.Z)(shouldShow ? "block" : "hidden", "z-[2] mx-auto mb-4 aspect-video h-full w-full items-center justify-center self-start [&>.videoAdPos]:grid [&>.videoAdPos]:aspect-video [&>.videoAdPos]:items-center [&>.videoAdPos]:bg-black/5", placeholderAds && "bg-mglGray200 text-mglGray300 before:flex before:h-full before:items-center before:justify-center before:content-['PUBLICIDADE']"),
                                children: [
                                    !placeholderAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdVideoGtm, {
                                        variant: "mobile"
                                    }),
                                    adVideoSpan1 && adVideoSpan1.finish()
                                ]
                            }, "".concat(index));
                        }
                        if ((0,CustomComponentComposer/* isCustomComponent */.m)(partHtml)) {
                            var customComposerSpan = newsContentSpan && newsContentSpan.startChild({
                                op: "customComposer",
                                description: JSON.stringify(partHtml)
                            });
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,className/* default */.Z)(shouldShow ? "block" : "hidden"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomComponentComposer/* default */.Z, {
                                        partHtml: partHtml,
                                        index: index,
                                        titulo: titulo
                                    }, index),
                                    customComposerSpan && customComposerSpan.finish()
                                ]
                            }, "".concat(index));
                        }
                        if (partHtml.tipo === "readMore" && !shouldRenderFullWhenMainCategoryIsMatch) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: !isOpen && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative z-[2] -ml-4 -mt-36 flex h-[200px] w-[calc(100%_+_2rem)] flex-col justify-end bg-gradient-to-t from-mglBlue400 via-mglBlue300 to-75% px-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "mb-12 flex w-full items-center justify-center rounded-[2rem] border-0 bg-mglGray900 p-2 text-base font-medium text-mglGray50 outline-none transition-all ease-in-out [&_svg]:ml-2 [&_svg]:fill-mglGray50",
                                        id: "read-more",
                                        onClick: handleClickOpened,
                                        children: "continuar lendo"
                                    })
                                })
                            }, index);
                        }
                        var contentComposerSpan = newsContentSpan && newsContentSpan.startChild({
                            op: "contentComposer",
                            description: JSON.stringify(partHtml)
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(shouldShow ? "contents" : "hidden"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentComposer/* default */.Z, {
                                    tipo: partHtml.tipo,
                                    as: partHtml.tag,
                                    url: partHtml.url,
                                    target: partHtml.target,
                                    valor: partHtml === null || partHtml === void 0 ? void 0 : partHtml.valor,
                                    atributos: partHtml === null || partHtml === void 0 ? void 0 : partHtml.atributos,
                                    className: (0,className/* default */.Z)(shouldShow ? "" : "hidden")
                                }, "".concat(partHtml.tipo, "-").concat(index)),
                                contentComposerSpan && contentComposerSpan.finish()
                            ]
                        }, "".concat(index));
                    }),
                    fonte && shouldShowFonte && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSource, {
                        fonte: fonte
                    })
                ]
            }),
            newsContentSpan && newsContentSpan.finish()
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Internals/Header/AdvertorialTag/index.tsx

function AdvertorialTag() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "inline-block h-8 w-[144px] rounded-[30px] border border-solid border-mglGray500 text-center text-xs font-medium uppercase leading-8 text-mglGray500",
        children: "PUBLIEDITORIAL"
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/PreferredSourceButton/index.tsx



// Fixo em produção: em homologação o leitor cadastraria `*.staging-canaltech.com.br`.
var PREFERRED_SOURCE_DOMAIN = "canaltech.com.br";
var PREFERRED_SOURCE_URL = "https://www.google.com/preferences/source?q=".concat(PREFERRED_SOURCE_DOMAIN);
var GOOGLE_BORDER_GRADIENT = "linear-gradient(90deg, #587DBD 0%, #319F43 25%, #F8BD00 50%, #E33629 100%)";
// Borda em gradiente: o fundo pinta a área interna (padding-box) e o gradiente
// pinta a faixa da borda (border-box), que fica transparente para deixá-lo aparecer.
var pillStyle = {
    border: "1px solid transparent",
    background: "linear-gradient(".concat(designSystemColors/* mglGray.mglGray100 */.Ce.mglGray100, ", ").concat(designSystemColors/* mglGray.mglGray100 */.Ce.mglGray100, ") padding-box, ").concat(GOOGLE_BORDER_GRADIENT, " border-box")
};
// Selo próprio, não o badge oficial do Google: o oficial PT-BR tem 338×106 px e não
// cabe na barra `h-8`. A doc do Google autoriza selo personalizado.
// Sem `share-button-click` — o GTM conta essa classe como compartilhamento.
function PreferredSourceButton(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        id: "PreferredSource",
        href: PREFERRED_SOURCE_URL,
        target: "_blank",
        rel: "noreferrer",
        title: "Prefira o Canaltech no Google",
        style: pillStyle,
        className: "inline-flex h-8 min-w-0 items-center gap-[9px] rounded-full px-3 text-[11px] font-normal leading-none text-mglGray700 no-underline shadow-[0_1px_2px_rgba(0,0,0,0.08)] transition-transform duration-200 hover:scale-105 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "truncate",
                children: "Prefira o CT no Google"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                icon: "google-g",
                width: 12,
                height: 12,
                viewBox: "0 0 48 48",
                className: "shrink-0"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/InternalShareButton/index.tsx













function InternalShareButton(param) {
    var title = param.title, description = param.description, url = param.url, _isAdvertorial = param.isAdvertorial, isAdvertorial = _isAdvertorial === void 0 ? false : _isAdvertorial;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var internalShareButtonSpan = currentSpan && currentSpan.startChild({
        op: "internalShareButton"
    });
    var ref1 = (0,react.useState)(false), isMenuOpen = ref1[0], setIsMenuOpen = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("phone"), 1), isMobile = ref2[0];
    var InternalBtnList = [
        {
            name: "Whatsapp",
            link: "https://web.whatsapp.com/send?text=".concat(encodeURIComponent(title), " ").concat(url),
            icon: "whatsapp",
            bgColor: "#25d366",
            linkApp: "whatsapp://send?text=".concat(encodeURIComponent(title), " ").concat(url),
            show: isMenuOpen
        },
        {
            name: "Facebook",
            link: "https://www.facebook.com/sharer/sharer.php?u=".concat(url),
            icon: "facebook",
            bgColor: "#3b5998",
            show: isMenuOpen
        },
        {
            name: "E-mail",
            link: "mailto:?subject=".concat(encodeURIComponent(title), "&body=").concat(encodeURIComponent(description), "%0D%0A%0D%0A Veja o conte\xfado completo em ").concat(url),
            icon: "email",
            bgColor: designSystemColors/* mglGray.mglGray900 */.Ce.mglGray900,
            show: isMenuOpen
        },
        {
            name: "Link",
            link: url,
            icon: "link-variant",
            bgColor: "#999",
            message: "Link copiado!",
            copyClipboard: true,
            show: isMenuOpen
        }, 
    ];
    var MobileBtnList = [
        {
            name: "Whatsapp",
            link: "https://web.whatsapp.com/send?text=".concat(encodeURIComponent(title), " ").concat(url),
            icon: "whatsapp",
            bgColor: "#25d366",
            linkApp: "whatsapp://send?text=".concat(encodeURIComponent(title), " ").concat(url),
            show: isMenuOpen
        },
        {
            name: "Facebook",
            link: "https://www.facebook.com/sharer/sharer.php?u=".concat(url),
            icon: "facebook",
            bgColor: "#3b5998",
            show: isMenuOpen
        },
        {
            name: "Link",
            link: url,
            icon: "link-variant",
            bgColor: "#999",
            message: "Link copiado!",
            copyClipboard: true,
            show: isMenuOpen
        }, 
    ];
    var getCorrectLink = function(btnProps) {
        var link;
        if (isMobile && (btnProps.name === "Whatsapp" || btnProps.name === "Telegram")) {
            link = btnProps.linkApp;
        } else if (btnProps.copyClipboard) {
            link = "";
        } else {
            link = btnProps.link;
        }
        return link;
    };
    // Mobile Layout Component
    var MobileLayout = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-8 flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex flex-col items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex w-full flex-row items-center justify-center gap-3 rounded-lg bg-mglGray50",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-full flex-row items-center gap-3",
                                children: [
                                    url && MobileBtnList.map(function(internalBtnProps) {
                                        var Tag = internalBtnProps.name === "Link" ? "button" : "a";
                                        var linkProps = {};
                                        if (getCorrectLink(internalBtnProps)) {
                                            linkProps = {
                                                href: getCorrectLink(internalBtnProps),
                                                target: "_blank",
                                                rel: "noreferrer"
                                            };
                                        }
                                        return /*#__PURE__*/ (0,react.createElement)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            id: internalBtnProps.name,
                                            className: "share-button-click flex h-8 w-8 items-center justify-center rounded-full shadow-sm transition-all duration-200 hover:scale-105",
                                            style: {
                                                backgroundColor: internalBtnProps.bgColor,
                                                border: 0
                                            }
                                        }, linkProps), {
                                            onClick: function(e) {
                                                if (internalBtnProps.copyClipboard) {
                                                    e.preventDefault();
                                                    navigator.clipboard.writeText(internalBtnProps.link);
                                                    window.alert(internalBtnProps.message);
                                                }
                                                setIsMenuOpen(false);
                                            },
                                            key: "btn-share-" + internalBtnProps.name,
                                            title: "Compartilhar com ".concat(internalBtnProps.name)
                                        }), /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,className/* default */.Z)("flex items-center justify-center text-xl", internalBtnProps.name === "Link" && "share-button-click"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, internalBtnProps.name === "Link" && {
                                                id: "LinkSVG"
                                            }), {
                                                icon: "mdi:".concat(internalBtnProps.icon),
                                                width: 20,
                                                height: 20,
                                                color: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
                                                viewBox: "0 0 24 24"
                                            }), internalBtnProps.name === "Link" && {
                                                className: "share-button-click"
                                            }))
                                        }));
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreferredSourceButton, {})
                                ]
                            })
                        })
                    })
                }),
                isAdvertorial && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertorialTag, {})
            ]
        });
    };
    // Desktop Layout Component
    var DesktopLayout = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-8 flex flex-col flex-wrap justify-between gap-3 tablet:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex flex-1 items-center",
                    children: [
                        url && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mr-2 hidden text-base font-light text-mglGray700 tablet:inline desktop:hidden largeDesktop:inline",
                            children: "Compartilhe: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex flex-1 flex-row items-center justify-center gap-2 rounded bg-mglGray50 transition-all duration-300 ease-ease",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-1 flex-wrap justify-center gap-2 tablet:flex-nowrap tablet:justify-normal",
                                children: [
                                    url && InternalBtnList.map(function(internalBtnProps) {
                                        var Tag = internalBtnProps.name === "Link" ? "button" : "a";
                                        var linkProps = {};
                                        if (getCorrectLink(internalBtnProps)) {
                                            linkProps = {
                                                href: getCorrectLink(internalBtnProps),
                                                target: "_blank",
                                                rel: "noreferrer"
                                            };
                                        }
                                        return /*#__PURE__*/ (0,react.createElement)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            id: internalBtnProps.name,
                                            className: "share-button-click flex h-8 w-8 items-center justify-center rounded-half",
                                            style: {
                                                backgroundColor: internalBtnProps.bgColor,
                                                border: 0
                                            }
                                        }, linkProps), {
                                            onClick: function(e) {
                                                if (internalBtnProps.copyClipboard) {
                                                    e.preventDefault();
                                                    navigator.clipboard.writeText(internalBtnProps.link);
                                                    window.alert(internalBtnProps.message);
                                                }
                                                setIsMenuOpen(false);
                                            },
                                            key: "btn-share-" + internalBtnProps.name,
                                            title: "Compartilhar com ".concat(internalBtnProps.name)
                                        }), /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,className/* default */.Z)("flex items-center justify-center text-2xl", internalBtnProps.name === "Link" && "share-button-click"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, internalBtnProps.name === "Link" && {
                                                id: "LinkSVG"
                                            }), {
                                                icon: "mdi:".concat(internalBtnProps.icon),
                                                width: 18,
                                                height: 18,
                                                color: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
                                                viewBox: "0 0 24 24"
                                            }), internalBtnProps.name === "Link" && {
                                                className: "share-button-click"
                                            }))
                                        }));
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreferredSourceButton, {
                                        className: "ml-auto"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                isAdvertorial && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertorialTag, {})
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLayout, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopLayout, {}),
            internalShareButtonSpan && internalShareButtonSpan.finish()
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Internals/Widgets/NewsLetter/NewsLetter.tsx
var NewsLetter = __webpack_require__(7601);
;// CONCATENATED MODULE: ./src/components/Internals/MainContent/index.tsx










var BlackFridayCall = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 81).then(__webpack_require__.bind(__webpack_require__, 81));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81)
            ];
        }
    },
    ssr: false
});
var EmbedOmny = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7788).then(__webpack_require__.bind(__webpack_require__, 5809));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5809)
            ];
        }
    }
});
var PodcastAggregators = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7343).then(__webpack_require__.bind(__webpack_require__, 7343));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7343)
            ];
        }
    }
});
var QuotedNewsBox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 62).then(__webpack_require__.bind(__webpack_require__, 62)).then(function(mod) {
        return mod.QuotedNewsBox;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62)
            ];
        }
    },
    ssr: false
});
var EditorialPartnersBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 246).then(__webpack_require__.bind(__webpack_require__, 246));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(246)
            ];
        }
    }
});
function MainContainer(param) {
    var headerImgData = param.headerImgData, article = param.article, _fonte = param.fonte, fonte = _fonte === void 0 ? "" : _fonte, _mainCategory = param.mainCategory, mainCategory = _mainCategory === void 0 ? "" : _mainCategory, _video = param.video, video = _video === void 0 ? null : _video, _podcast = param.podcast, podcast = _podcast === void 0 ? null : _podcast, _citados = param.citados, citados = _citados === void 0 ? null : _citados, _titulo = param.titulo, titulo = _titulo === void 0 ? "" : _titulo, _type = param.type, type = _type === void 0 ? "" : _type, _capa = param.capa, capa = _capa === void 0 ? null : _capa, _widget = param.widget, widget = _widget === void 0 ? null : _widget, _widgetBf = param.widgetBf, widgetBf = _widgetBf === void 0 ? false : _widgetBf, _placeholderAds = param.placeholderAds, placeholderAds = _placeholderAds === void 0 ? false : _placeholderAds, _shouldRenderAdsGoogle = param.shouldRenderAdsGoogle, shouldRenderAdsGoogle = _shouldRenderAdsGoogle === void 0 ? true : _shouldRenderAdsGoogle, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _precos = param.precos, precos = _precos === void 0 ? null : _precos, _flags = param.flags, flags = _flags === void 0 ? 0 : _flags, _editoria = param.editoria, editoria = _editoria === void 0 ? undefined : _editoria, _parceiros = param.parceiros, parceiros = _parceiros === void 0 ? undefined : _parceiros, _isHeader = param.isHeader, isHeader = _isHeader === void 0 ? undefined : _isHeader, _description = param.description, description = _description === void 0 ? "" : _description, _url = param.url, url = _url === void 0 ? "" : _url, _isNewsOpen = param.isNewsOpen, isNewsOpen = _isNewsOpen === void 0 ? false : _isNewsOpen, _enableNewsLetter = param.enableNewsLetter, enableNewsLetter = _enableNewsLetter === void 0 ? false : _enableNewsLetter;
    var ref, ref1, ref2;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var mainContentSpan = currentSpan && currentSpan.startChild({
        op: "mainContent"
    });
    var hasPartnerLinks = (flags & 512) !== 0;
    // eslint-disable-next-line no-bitwise
    var isAdvertorial = type === "artigo" && (flags & 2) !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,className/* default */.Z)("[grid-column:1] desktop:[grid-column-end:2] desktop:[grid-column-start:1]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalShareButton, {
                        title: titulo,
                        description: description,
                        url: url,
                        isAdvertorial: isAdvertorial
                    }),
                    (editoria === null || editoria === void 0 ? void 0 : (ref1 = editoria.logo) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorialPartnersBanner, {
                        editoria: editoria,
                        parceiros: parceiros !== null && parceiros !== void 0 ? parceiros : []
                    }),
                    (headerImgData === null || headerImgData === void 0 ? void 0 : headerImgData.url) && !video && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImage/* default */.Z, {
                        url: headerImgData.url,
                        srcset: headerImgData.srcset,
                        alt: headerImgData.alt,
                        caption: headerImgData.caption || titulo,
                        hasTarja: !!(editoria === null || editoria === void 0 ? void 0 : (ref2 = editoria.logo) === null || ref2 === void 0 ? void 0 : ref2.url),
                        isHeader: isHeader
                    }),
                    (video === null || video === void 0 ? void 0 : video.idYoutube) && /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrameYoutube/* default */.Z, {
                        videoTitle: video.titulo,
                        videoId: video.idYoutube,
                        capa: capa,
                        lazy: true
                    }),
                    podcast && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedOmny, {
                        titulo: titulo,
                        dataPodcast: podcast
                    }),
                    podcast && /*#__PURE__*/ (0,jsx_runtime.jsx)(PodcastAggregators, {
                        aggregatorsData: article.botoes,
                        dataPodcast: podcast
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsContent, {
                        dataContent: article,
                        widget: widget,
                        placeholderAds: placeholderAds,
                        shouldRenderAdsGoogle: shouldRenderAdsGoogle,
                        isSubDomain: isSubDomain,
                        product: precos && precos.length > 0 && precos[0],
                        titulo: titulo,
                        hasPartnerLinks: hasPartnerLinks,
                        isNewsOpen: isNewsOpen,
                        mainCategory: mainCategory,
                        fonte: fonte
                    }),
                    enableNewsLetter && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsLetter/* default */.Z, {}),
                    (hasPartnerLinks || !!(citados === null || citados === void 0 ? void 0 : citados.length) || widgetBf) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
                        height: 1,
                        children: [
                            hasPartnerLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6 rounded bg-mglGray200 p-4 text-xs font-light text-mglGray500",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Este artigo possui links de lojas parceiras do Canaltech. Se voc\xea comprar o produto sugerido, podemos receber uma pequena comiss\xe3o. O programa de afiliados n\xe3o influencia nosso conte\xfado editorial, que tem as liberdades de imprensa e de opini\xe3o garantidas."
                                    })
                                })
                            }),
                            !!(citados === null || citados === void 0 ? void 0 : citados.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotedNewsBox, {
                                citados: citados,
                                type: video ? "video" : "podcast"
                            }),
                            widgetBf && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackFridayCall, {})
                        ]
                    })
                ]
            }),
            mainContentSpan && mainContentSpan.finish()
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/SponsoredCategoryHeader/index.tsx
var SponsoredCategoryHeader = __webpack_require__(2155);
// EXTERNAL MODULE: ./src/lib/sponsors.ts
var sponsors = __webpack_require__(6874);
;// CONCATENATED MODULE: ./src/components/Internals/NewsItem/index.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 














// Fallback degradante de `alt` com normalização de whitespace:
//   1. `alt` curado do Directus
//   2. `creditos` (matéria legada do monolito)
//   3. `titulo` da matéria (última linha de defesa — capa é informativa)
// `.trim()` evita que strings só com espaços (comum em payload de CMS) sejam
// truthy e bloqueiem o fallback semântico para o nível seguinte.
var normalizeAccessibleAlt = function() {
    for(var _len = arguments.length, candidates = new Array(_len), _key = 0; _key < _len; _key++){
        candidates[_key] = arguments[_key];
    }
    return candidates.map(function(v) {
        return typeof v === "string" ? v.trim() : "";
    }).find(Boolean) || "";
};
function NewsItem(param) {
    var newsData = param.newsData, _newsPreview = param.newsPreview, newsPreview = _newsPreview === void 0 ? false : _newsPreview, _isCurrentPage = param.isCurrentPage, isCurrentPage = _isCurrentPage === void 0 ? false : _isCurrentPage, _type = param.type, type = _type === void 0 ? "" : _type;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("tablet"), 1), isTabletOrMobile = ref5[0];
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var newsItemSpan = currentSpan && currentSpan.startChild({
        op: "newsItem"
    });
    var SideContent = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 4942).then(__webpack_require__.bind(__webpack_require__, 4942));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(4942)
                ];
            }
        }
    });
    var router = (0,next_router.useRouter)();
    var capa = newsData.capa, conteudo = newsData.conteudo, podcast = newsData.podcast, url = newsData.url;
    var hasCoverImage = Boolean(capa === null || capa === void 0 ? void 0 : capa.url);
    var pageUri = url;
    if (!capa) {
        var ref6, ref7;
        (0,esm_exports/* captureMessage */.uT)("NewsItem renderizado sem capa", {
            level: "warning",
            tags: {
                url: url,
                tipo: (ref6 = newsData === null || newsData === void 0 ? void 0 : newsData.tipo) !== null && ref6 !== void 0 ? ref6 : "unknown",
                tipoPublicacao: (ref7 = newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao) !== null && ref7 !== void 0 ? ref7 : "unknown"
            }
        });
    }
    var IdsPg = newsData.widget && ((ref1 = newsData.widget) === null || ref1 === void 0 ? void 0 : ref1.tipo) === "produto" && type === "analise" ? [
        newsData.cu,
        (ref2 = newsData.widget) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.dados) === null || ref3 === void 0 ? void 0 : ref3.cu
    ] : newsData.cu;
    var categories = undefined;
    if (newsData === null || newsData === void 0 ? void 0 : newsData.categorias) categories = newsData === null || newsData === void 0 ? void 0 : newsData.categorias;
    var mainCategory = (newsData === null || newsData === void 0 ? void 0 : newsData.categoriaPrincipal) || undefined;
    var publicationType = newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao;
    // eslint-disable-next-line no-bitwise
    var isAdvertorial = type === "artigo" && (newsData.flags & 2) !== 0;
    var isOffer = type === "artigo" && (newsData.flags & 32) !== 0;
    // Categorias patrocinadas (tutoriais/smartphone) mantêm o header de patrocínio
    // legado. A tarja de editoria NÃO passa mais por aqui — é data-driven pela
    // `editoria` (cor + logo do Directus) resolvida no MainContent.
    var isSponsoredOrEditorialCategory = undefined;
    var sponsoredCategory = undefined;
    if (categories && mainCategory) {
        isSponsoredOrEditorialCategory = (0,sponsors/* isSponsoredOrEditorialToInternal */.xu)(mainCategory, categories, publicationType);
        if ((categories || publicationType) && isSponsoredOrEditorialCategory === "sponsored") {
            sponsoredCategory = (0,sponsors/* getSponsoredCategoryOrTypeWithStringToInternal */.SU)(categories, mainCategory, publicationType);
        }
    }
    var shouldRenderAdsGoogle = !isAdvertorial;
    var shouldRenderAdsByType = type !== "video" && type !== "podcast" && type !== "analise" && type !== "artigo";
    // Artigos (TIPO_ARTIGOS = 8) passam a exibir a newsletter: o tipo "Artigo" do
    // Directus assume o fluxo que antes era de Matérias, e Matéria sempre teve o
    // widget. Mantemos a supressão para Listas, Análises e Tutoriais.
    var enableNewsLetter = (newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao) !== "11" && // TIPO_LISTAS
    (newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao) !== "2" && // TIPO_ANALISES
    (newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao) !== "4" && // TIPO_TUTORIAIS
    !isAdvertorial && // Publieditorial é uma flag na matéria.
    !isOffer; // Oferta é uma flag na matéria.
    (0,react.useEffect)(function() {
        var navigate = function() {
            router.push(window.location.href);
        };
        window.onpopstate = navigate;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "route-uri",
        "data-uri-page": pageUri,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
                isOnHeader: true,
                hasBreadcrumb: true,
                children: [
                    isSponsoredOrEditorialCategory === "sponsored" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsoredCategoryHeader/* SponseredCategoryHeader */.i, {
                        sponsoredCategory: sponsoredCategory
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        breadcrumb: newsData.breadcrumb,
                        titulo: newsData.titulo,
                        publicacao: newsData.publicacao,
                        isAdvertorial: isAdvertorial,
                        isSubDomain: Boolean(newsData.dominio),
                        type: type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsItem_styles/* GridInternal */.J, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContainer, {
                                // `alt` com fallback degradante em três níveis: `capa.alt` →
                                // `capa.creditos` → `newsData.titulo`. Capa de notícia é imagem
                                // informativa (WCAG 2.1 §1.1.1), nunca decorativa — evita
                                // `alt=""` que silenciaria a imagem para leitores de tela.
                                // Guard `hasCoverImage` protege contra matérias sem `imagem_capa`
                                // (ex.: tipo vídeo + payload legado sem thumbnail) — não monta
                                // `headerImgData` quebrado que faria preload de URL vazia.
                                headerImgData: hasCoverImage && capa ? {
                                    url: capa.url,
                                    alt: normalizeAccessibleAlt(capa.alt, capa.creditos, newsData === null || newsData === void 0 ? void 0 : newsData.titulo),
                                    caption: capa.creditos || "",
                                    blurhash: capa.blurhash,
                                    srcset: capa.srcset
                                } : undefined,
                                article: conteudo,
                                fonte: newsData.fonte,
                                mainCategory: mainCategory,
                                widget: (newsData === null || newsData === void 0 ? void 0 : newsData.widget) || conteudo.widget,
                                video: newsData === null || newsData === void 0 ? void 0 : newsData.video,
                                citados: newsData === null || newsData === void 0 ? void 0 : newsData.citados,
                                capa: newsData.capa,
                                podcast: podcast,
                                titulo: newsData.titulo,
                                description: newsData.tituloAlt,
                                url: newsData.encurtador,
                                type: type,
                                placeholderAds: newsPreview,
                                shouldRenderAdsGoogle: shouldRenderAdsGoogle,
                                widgetBf: newsData === null || newsData === void 0 ? void 0 : (ref4 = newsData.conteudo) === null || ref4 === void 0 ? void 0 : ref4.blocoBlackFriday,
                                isSubDomain: Boolean(newsData.dominio),
                                flags: newsData.flags,
                                precos: newsData === null || newsData === void 0 ? void 0 : newsData.precos,
                                editoria: newsData === null || newsData === void 0 ? void 0 : newsData.editoria,
                                parceiros: newsData === null || newsData === void 0 ? void 0 : newsData.parceiros,
                                isHeader: "internal",
                                isNewsOpen: isAdvertorial,
                                enableNewsLetter: enableNewsLetter && isTabletOrMobile
                            }),
                            !isTabletOrMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideContent, {
                                placeholderAds: newsPreview,
                                shouldRenderAds: shouldRenderAdsGoogle,
                                enableNewsLetter: enableNewsLetter
                            })
                        ]
                    })
                ]
            }),
            !newsPreview && shouldRenderAdsByType && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AdContainer */.g1, {
                children: shouldRenderAdsByType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                            type: "billboard/footer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                            type: "rectangle/footer"
                        })
                    ]
                })
            }),
            newsItemSpan && newsItemSpan.finish()
        ]
    });
}


/***/ }),

/***/ 6561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ GridInternal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    GridInternal: {
        singleColumn: {
            true: "singleColumn [&.singleColumn]:desktop:grid-cols-1",
            false: ""
        }
    }
};
var GridInternal = function(_param) {
    var children = _param.children, singleColumn = _param.singleColumn, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleColumn"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("mt-4 grid grid-cols-1 grid-rows-1 gap-0 desktop:grid-cols-[minmax(0,1fr)_336px] desktop:gap-8", singleColumn != undefined && variants.GridInternal.singleColumn[singleColumn.toString()])
    }, rest), {
        children: children
    }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    GridInternal: GridInternal
});


/***/ }),

/***/ 7601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsLetter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8469);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9659);
/* harmony import */ var _components_Layout_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9642);






function NewsLetter(param) {
    var _title = param.title, title = _title === void 0 ? "Seu resumo inteligente do mundo tech!" : _title, _description = param.description, description = _description === void 0 ? "Assine a newsletter do Canaltech e receba not\xedcias e reviews sobre tecnologia em primeira m\xe3o." : _description, _inputPlaceHolder = param.inputPlaceHolder, inputPlaceHolder = _inputPlaceHolder === void 0 ? "Preencha seu e-mail" : _inputPlaceHolder, _buttonContent = param.buttonContent, buttonContent = _buttonContent === void 0 ? "inscreva-se" : _buttonContent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), termChecked = ref1[0], setTermChecked = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasSubmitted = ref2[0], setHasSubmitted = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), responseText = ref3[0], setResponseText = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), responseTitle = ref4[0], setResponseTitle = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), error = ref5[0], setError = ref5[1];
    var handleSubmit = function(event) {
        event.preventDefault();
        if (termChecked) if (email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {
            _services_api__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/artigo/newsletter/", {
                email: email
            }).then(function(response) {
                if (response.status === 200) {
                    setResponseTitle("Obrigado por se inscrever!");
                    setHasSubmitted(true);
                    setTermChecked(false);
                    setResponseText("Estamos muito felizes em ter voc\xea com a gente!\n" + "Agora voc\xea faz parte da nossa comunidade e receber\xe1, em primeira m\xe3o, as principais not\xedcias e an\xe1lises sobre o mundo da tecnologia.\n\n" + "Fique de olho no seu e-mail — tem muita novidade boa chegando por a\xed!");
                    setError("");
                }
            }).catch(function(err) {
                setError("ResponseError");
                setResponseTitle("Ocorreu um erro!");
            });
        } else {
            setError("ValidationError");
        }
        else {
            setError("ValidationTerm");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (error) {
            var timeout = setTimeout(function() {
                return setError("");
            }, 3000);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        error
    ]);
    var getErrorText = function() {
        if (error === "ValidationError") return "Por favor, verifique se o e-mail foi digitado corretamente.";
        if (error === "ResponseError") return "N\xe3o foi poss\xedvel cadastrar o seu e-mail. Tente novamente.";
        if (error === "ValidationTerm") return "Por favor, aceite os termos de uso e pol\xedtica de privacidade.";
        return "";
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col rounded bg-mglBlue300 p-6 text-mglGray50 mt-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            width: 34,
                            height: 18.42,
                            icon: "mail-send",
                            color: _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglGray.mglGray50 */ .Ce.mglGray50,
                            className: "mr-2 mt-1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("font-lexend font-semibold text-base leading-[130%] align-middle", responseTitle === "Obrigado por se inscrever!" ? "mb-0" : "mb-2 "),
                        children: hasSubmitted ? responseTitle : title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mb-6 font-lexend font-normal text-[14px] leading-[150%] tracking-[0px] align-middle",
                children: hasSubmitted ? responseText : description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-4 flex w-full flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("mb-2 text-xs font-semibold ", error === "ValidationError" ? "text-[rgb(255,85,85)]" : "text-mglGray50"),
                        children: "E-mail"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                        className: "flex w-full flex-col",
                        onSubmit: function(e) {
                            return handleSubmit(e);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr-4 flex w-full flex-row items-center rounded bg-mglGray50 p-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    className: "h-6 w-full rounded border-none bg-mglGray50 p-2 outline-none font-open-sans font-normal text-xs leading-none tracking-[0%]",
                                    type: "email",
                                    value: email,
                                    autoFocus: error === "ValidationError",
                                    onChange: function(e) {
                                        return setEmail(e.target.value);
                                    },
                                    placeholder: inputPlaceHolder
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "border-1 mt-2 w-full rounded border border-solid border-mglBlue300 bg-mglGray50 p-3 text-mglBlue300 outline-none transition-all duration-300 ease-in-out hover:border-mglGray50 hover:bg-mglBlue300 hover:text-mglGray50",
                                type: "submit",
                                children: buttonContent
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("mt-4 flex flex-row", error === "ValidationTerm" ? "text-[rgb(255,85,85)]" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        checked: termChecked,
                        onChange: function() {
                            return setTermChecked(!termChecked);
                        },
                        className: "text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 ml-1 mr-1 h-4 w-4 rounded-sm focus:ring-2",
                        id: "newsletter-checkbox"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        htmlFor: "newsletter-checkbox",
                        className: "cursor-pointer font-open-sans font-normal text-[12px] leading-[16px] tracking-[0%] align-middle text-mglGray50",
                        children: [
                            "Confirmo que li, aceito e concordo com os",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://canaltech.com.br/privacidade/",
                                className: "text-mglGray50 font-open-sans font-normal text-[12px] leading-[16px] tracking-[0%] align-middle",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "Termos de Uso e Pol\xedtica de Privacidade do Canaltech."
                                })
                            }),
                            " "
                        ]
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-2 text-sm text-[rgb(255,85,85)]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                    children: [
                        "*** ",
                        getErrorText()
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 7517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/styles.tsx




var BreadcrumbItemContainer = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex flex-row items-center font-light text-mglGray500 before:mr-2 before:flex before:h-[13px] before:w-2 before:items-center before:justify-center before:pb-[3px] before:text-center before:text-base before:leading-none before:content-['›'] first-of-type:before:content-none"
    }, props), {
        children: props.children
    }));
};
var BreadcrumbItem = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex h-4 flex-row items-center text-xs leading-4 text-mglGray500 no-underline"
    }, props), {
        ref: ref,
        children: props.children
    }));
});


// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/index.tsx
/* eslint-disable react/no-array-index-key */ 





var publicRuntimeConfig = config_default()().publicRuntimeConfig;
function Breadcrumb(param) {
    var breadcrumbList = param.breadcrumbList, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var breadcrumbSpan = currentSpan && currentSpan.startChild({
        op: "breadcrumb"
    });
    var workingList = (0,_to_consumable_array/* default */.Z)(breadcrumbList).filter(function(item) {
        return item.url !== "/";
    });
    workingList.unshift({
        titulo: "Home",
        url: "/"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "place-content-[center_start] mb-2 flex flex-wrap items-center gap-2",
        children: [
            workingList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItemContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: isSubDomain ? "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(item.url) : item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItem, {
                            title: "Ir para ".concat(item.titulo),
                            children: item.titulo
                        })
                    })
                }, item.url);
            }),
            breadcrumbSpan && breadcrumbSpan.finish()
        ]
    });
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 2434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InternalTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function InternalTitle(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "text-2xl font-medium text-mglGray900 tablet:text-4xl",
        children: title
    });
}


/***/ }),

/***/ 2747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bL": function() { return /* binding */ BillboardContainer; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "hn": function() { return /* binding */ ContentListNews; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    AdContainer: {
        noPadding: {
            true: "noPadding [&.noPadding]:p-0"
        },
        billboard: {
            true: "h-[250px] hidden tablet:flex"
        }
    },
    ContentListNews: {
        singleRow: {
            true: "grid-rows-[auto]"
        }
    }
};
var AdContainer = function(_param) {
    var children = _param.children, noPadding = _param.noPadding, billboard = _param.billboard, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "noPadding",
        "billboard"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex min-h-0 items-center justify-center bg-mglGray50 px-0 py-5", noPadding != undefined && variants.AdContainer.noPadding[noPadding.toString()], billboard != undefined && variants.AdContainer.billboard[billboard.toString()])
    }, rest), {
        children: children
    }));
};
var ContentListNews = function(_param) {
    var children = _param.children, singleRow = _param.singleRow, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleRow"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("ml-0 grid grid-cols-1 grid-rows-2 gap-5 [grid-auto-columns:1fr] tablet:ml-auto tablet:grid-cols-2 desktop:grid-cols-3 [&_a]:mx-0 [&_a]:my-5 [&_a]:no-underline ", singleRow != undefined && variants.ContentListNews.singleRow[singleRow.toString()])
    }, rest), {
        children: children
    }));
};
var BillboardContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "m-0 hidden tablet:mx-[-8.335%] tablet:my-0 tablet:flex"
    }, rest), {
        children: children
    }));
};


/***/ }),

/***/ 2155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ SponseredCategoryHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_sponsors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6874);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



var SponseredCategoryHeader = function(param) {
    var sponsoredCategory = param.sponsoredCategory, _logoSize = param.logoSize, logoSize = _logoSize === void 0 ? undefined : _logoSize;
    var sponsorData = _lib_sponsors__WEBPACK_IMPORTED_MODULE_1__/* .sponsorCategoryData */ .Bw[sponsoredCategory];
    if (!sponsorData) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-4 flex flex-col items-end justify-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mb-1 text-[10px] font-light text-mglGray500",
                children: "Conte\xfado apoiado por"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-row gap-2",
                children: sponsorData.map(function(sponsor, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-row items-center"),
                        href: sponsor.url,
                        rel: "sponsored",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            title: sponsor.title,
                            src: sponsor.image.desktop.src,
                            height: sponsor.image.desktop.height,
                            width: sponsor.image.desktop.width,
                            alt: sponsor.title
                        })
                    }, "".concat(index));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                className: "mt-4 w-full border-t border-mglGray100 border-opacity-20"
            })
        ]
    });
};


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 6874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ sponsorCategoryData; },
/* harmony export */   "P2": function() { return /* binding */ enableSponsoredCategories; },
/* harmony export */   "PV": function() { return /* binding */ getEditorialCategory; },
/* harmony export */   "Rt": function() { return /* binding */ getSponsoredCategory; },
/* harmony export */   "SU": function() { return /* binding */ getSponsoredCategoryOrTypeWithStringToInternal; },
/* harmony export */   "xu": function() { return /* binding */ isSponsoredOrEditorialToInternal; }
/* harmony export */ });
/* unused harmony exports sponsoredCategoriesUri, getEditorialCategoryWithStringToInternal */
var sponsorCategoryData = {
    tutoriais: [
        {
            url: "https://www.kaspersky.com.br/premium?reseller=br_eg-mf_acq_ona_dis__onl_b2c_canaltech_ban_______&utm_content=banner%7Cgeneric&utm_source=canaltech&utm_medium=display&utm_term=youtube&utm_campaign=",
            title: "Ir para o site do Kaspersky!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                }
            }
        }, 
    ],
    smartphone: [
        {
            url: "https://www.motorola.com.br/",
            title: "Ir para o site da Motorola!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                }
            }
        }, 
    ]
};
var enableSponsoredCategories = [
    "tutoriais",
    "smartphone"
];
var sponsoredCategoriesUri = (/* unused pure expression or super */ null && ([
    "tutoriais",
    "smartphone"
]));
var editorialCategoriesCtupUri = [
    "hardware",
    "games",
    "ctup",
    "notebook"
];
var sponsoredCategoriesTutorialsTitle = [
    "Tutoriais"
];
var sponsoredpublicationType = [
    "4"
];
var editorialCategoriesCtupTitle = [
    "Hardware",
    "Games",
    "Notebook"
];
var editorialCategoriesCtAutoTitle = [
    "Ve\xedculos",
    "Carros",
    "Mobilidade Urbana",
    "Ve\xedculos Aut\xf4nomos"
];
var getSponsoredCategory = function(singleCategory) {
    if (singleCategory === "tutoriais") return "tutoriais";
    if (singleCategory === "smartphone") return "smartphone";
    return undefined;
};
var getEditorialCategory = function(singleCategory) {
    if (editorialCategoriesCtupUri.includes(singleCategory)) return "ctup";
    if (singleCategory === "eletro" || singleCategory === "ct-eletro") return "eletro";
    if (singleCategory === "ctauto") return "ctauto";
    return undefined;
};
var isSponsoredOrEditorialToInternal = function(mainCategory, categories) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    if (sponsoredCategoriesTutorialsTitle.includes(mainCategory)) return "sponsored";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) return "editorial";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) return "editorial";
    if (mainCategory === "CT Eletro") return "editorial";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) return "sponsored";
    if (sponsoredpublicationType.includes(publicationType)) return "sponsored";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) return "editorial";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) return "editorial";
    if (categories.includes("CT Eletro")) return "editorial";
    return undefined;
};
var getSponsoredCategoryOrTypeWithStringToInternal = function(categories, mainCategory) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    var category = undefined;
    if (mainCategory && sponsoredCategoriesTutorialsTitle.includes(mainCategory)) category = "tutoriais";
    if (sponsoredpublicationType.includes(publicationType)) category = "tutoriais";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) category = "tutoriais";
    if (!enableSponsoredCategories.includes(category)) return undefined;
    return category;
};
var getEditorialCategoryWithStringToInternal = function(categories, mainCategory) {
    var category = undefined;
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) category = "ctup";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) category = "ctauto";
    if (categories.includes("CT Eletro")) category = "eletro";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) category = "ctup";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) category = "ctauto";
    if (mainCategory === "CT Eletro") category = "eletro";
    return category;
};


/***/ }),

/***/ 8469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ny": function() { return /* binding */ mimir; },
/* harmony export */   "hi": function() { return /* binding */ api; }
/* harmony export */ });
/* unused harmony exports retryDelayWithJitter, site, validatesResponse, guia, directus */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios_retry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8662);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(3454);





var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_2___default()().publicRuntimeConfig;
// Em ambientes onde o ingress-nginx-controller exige PROXY protocol (LBaaS MGC),
// o tráfego intra-cluster Pod→ExternalIP morre com ECONNRESET. Em SSR usamos a
// URL interna do cluster (process.env, server-only). No browser, mantemos o
// host público. Em produção (sem INTERNAL_API_* definida no deployment),
// o fallback mantém o host público — comportamento inalterado.
var isServer = "object" === "undefined";
var apiBaseSSR = process.env.INTERNAL_API_BASE || publicRuntimeConfig.NEXT_PUBLIC_API_BASE;
var mimirBaseSSR = process.env.INTERNAL_API_MIMIR || publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR;
var guiaBaseSSR = process.env.INTERNAL_API_GUIA || publicRuntimeConfig.NEXT_PUBLIC_API_GUIA;
var api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(isServer ? apiBaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_BASE, "/api"),
    timeout: 10000,
    responseType: "json"
});
var site = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(isServer ? apiBaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_BASE, "/").concat(publicRuntimeConfig.NEXT_PUBLIC_API_VERSION),
    timeout: 10000,
    responseType: "json"
});
var mimir = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: isServer ? mimirBaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR,
    timeout: 10000,
    responseType: "json"
});
var guia = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: isServer ? guiaBaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_GUIA,
    timeout: 10000,
    responseType: "json"
});
// Directus é M2M/SSR-only (ver directusMateria.ts, chamado só de getServerSideProps).
// Base e token vêm de process.env (server-only) — NÃO de publicRuntimeConfig, que
// é serializado no bundle e vazaria o token no browser. No client, baseURL fica
// undefined e o guard `if (!directus.defaults.baseURL) return null` curto-circuita.
var directus = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: process.env.DIRECTUS_BASE,
    timeout: 10000,
    responseType: "json"
});
api.interceptors.request.use(function(config) {
    config.url = encodeURI(config.url);
    return config;
});
site.interceptors.request.use(function(config) {
    config.url = encodeURI(config.url);
    return config;
});
directus.interceptors.request.use(function(config) {
    config.url = encodeURI(config.url);
    config.params = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, config.params), {
        access_token: process.env.DIRECTUS_TOKEN
    });
    return config;
});
// 408 Request Timeout,
// 500 Internal Server Error,
// 502 Bad Gateway,
// 503 Service Unavailable ,
// 504 Gateway Timeout
// Se ECONNABORTED, vem do timeOut do Axios
// Se isNetworkOrIdempotentRequestError validado pelo axiosRetry
// Backoff exponencial puro (2^n * 100ms) acrescido de ±50% de jitter random.
// Diferente do `axiosRetry.exponentialDelay` (que adiciona apenas 0-20% pra
// cima), este expande o range pros dois lados — dispersa mais agressivamente
// rajadas simultâneas. Sob 100+ requests SSR concorrentes retentando ao mesmo
// tempo, o backend recebe um "thundering herd" exato a cada 200/400/800ms,
// e o colapso cascateia. ±50% transforma o spike em uma curva suave.
var RETRY_BASE_DELAY_MS = 100;
var RETRY_JITTER_RATIO = 0.5;
function retryDelayWithJitter(retryCount) {
    var base = Math.pow(2, retryCount) * RETRY_BASE_DELAY_MS;
    var jitter = base * RETRY_JITTER_RATIO * (Math.random() - 0.5) * 2;
    return Math.max(0, base + jitter);
}
var retryableHttpStatus = function(status) {
    return status === 408 || status === 500 || status === 502 || status === 503 || status === 504;
};
var shouldRetry = function(error) {
    var ref;
    return retryableHttpStatus((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) || error.code === "ECONNABORTED" || axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isNetworkOrIdempotentRequestError */ .ZP.isNetworkOrIdempotentRequestError(error);
};
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: retryDelayWithJitter,
    retryCondition: shouldRetry
});
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(site, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: retryDelayWithJitter,
    retryCondition: shouldRetry
});
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(directus, {
    retries: 3,
    shouldResetTimeout: true,
    retryDelay: retryDelayWithJitter,
    retryCondition: shouldRetry
});
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(mimir, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: retryDelayWithJitter,
    retryCondition: shouldRetry
});
var validatesResponse = function(dataResponseAPI) {
    var isCatch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, isCategory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, category = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", host = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, prevHost = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, pathName = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    var ref, ref1, ref2, ref3;
    // Usando o CT status que são:
    // case 0: //sucesso(200)
    // case 1: //erro no servidor(500)
    // case 2: //acesso negado(403)
    // case 3: //não encontrado(404)
    // case 4: //inconsistencia(400)
    // case 5: //metodo não permitido(405)
    // case 6: //redirect(301)
    // case 7: //redirect(301)
    var data = null;
    var statusCode = 0;
    if (!isCatch && dataResponseAPI) {
        data = dataResponseAPI.data;
        statusCode = dataResponseAPI.status;
        if ((data === null || data === void 0 ? void 0 : data.status) == null) {
            return {
                data: data,
                statusCode: statusCode
            };
        }
    }
    switch(isCatch ? (ref = dataResponseAPI.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.status : dataResponseAPI.data.status){
        case 3:
            if (!isCategory) {
                data = {
                    notFound: true,
                    props: {}
                };
            } else {
                data = {
                    redirect: {
                        statusCode: 301,
                        destination: "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL, "/").concat(category, "/")
                    },
                    props: {}
                };
            }
            break;
        case 8:
            return {
                data: {
                    headers: isCatch ? dataResponseAPI.response.data.headers : data.headers
                },
                statusCode: isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo
            };
            break;
        case 1:
        case 2:
        case 4:
        case 5:
            statusCode = isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo;
            break;
        case 6:
        case 7:
            data = {
                redirect: {
                    statusCode: isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo,
                    destination: isCatch ? dataResponseAPI.response.data.data.url : data.data.url
                },
                props: {}
            };
            break;
        default:
            if (isCatch) throw dataResponseAPI;
            statusCode = dataResponseAPI.status;
    }
    var localHost = publicRuntimeConfig.NEXT_PUBLIC_HOST;
    var desiredHost = (dataResponseAPI === null || dataResponseAPI === void 0 ? void 0 : (ref2 = dataResponseAPI.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.dominio) || localHost;
    // Não redireciona se já estamos servindo o host canônico deste deploy.
    // No preview (host = directus.hml.staging-canaltech.com.br) a API consumida é a do
    // staging, que declara `dominio = staging-canaltech.com.br`; sem este guard toda página
    // de conteúdo era expulsa pro staging. Prod/staging seguem canonicalizando hosts estrangeiros.
    if ((host === null || host === void 0 ? void 0 : host.toString()) !== (desiredHost === null || desiredHost === void 0 ? void 0 : desiredHost.toString()) && (host === null || host === void 0 ? void 0 : host.toString()) !== (localHost === null || localHost === void 0 ? void 0 : localHost.toString())) {
        var ref4, ref5;
        data = {
            redirect: {
                statusCode: 301,
                destination: "https://".concat(desiredHost).concat((dataResponseAPI === null || dataResponseAPI === void 0 ? void 0 : (ref4 = dataResponseAPI.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.url) || pathName || "")
            },
            props: {}
        };
    }
    // Erros de servidor/acesso (status 1/2/4/5) no caminho isCatch só setam statusCode e deixam
    // `data` nulo. Garante shape válido para os callers não estourarem em data.redirect. (FAWKES-37R)
    if (!data) {
        data = {
            notFound: true,
            props: {}
        };
    }
    return {
        data: data,
        statusCode: statusCode
    };
};



/***/ })

}]);